<template>
  <div>
    <AdminNavbar />
    <div class="container mt-3">
      <CustomAlert title="Metrics" type="warning" icon="bi-exclamation-circle">
        <p class="mb-0">Under development.</p>
      </CustomAlert>
      <!-- Admin Metrics Start -->
      <div class="card card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <div class="h4 fw-bold">{{ title }}</div>
            <div class="fst-italic">{{ description }}</div>
          </div>
        </div>
        <table class="table border table-striped text-start">
          <thead>
            <tr>
              <th v-for="metric in metrics" :key="metric.key" scope="col">
                {{ metric.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in data" :key="index">
              <td v-for="metric in metrics" :key="metric.key">
                {{ row[metric.key] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- Admin Metrics End -->
    </div>
  </div>
</template>

<script>
import AdminNavbar from "@/admin/components/AdminNavbar";
import { readMetricsEntries } from "@/apis/metrics";
import CustomAlert from "@/components/ui/CustomAlert";

export default {
  name: "SettingsView",
  components: {
    AdminNavbar,
    CustomAlert
  },
  data() {
    return {
      title: "Analytics",
      description: "Below is the list of metrics information.",
      data: [], // Rows of data
      metrics: [] // Column headers
    };
  },
  created() {
    const page = "Sheet1";
    const id = process.env.VUE_APP_METRICS_API_KEY;

    readMetricsEntries(page, id)
      .then((response) => {
        if (response && response.data && response.data.message) {
          const retrievedData = response.data.message;

          if (retrievedData.length > 0) {
            // Use the keys from the first object in the array as column headers
            this.metrics = Object.keys(retrievedData[0]).map((key) => ({
              key,
              label: key
            }));
          }
          this.data = retrievedData;
        }
      })
      .catch((error) => {
        console.error("Error fetching metrics:", error);
      });
  }
};
</script>
